import { changePickupFrequencyDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getchangePickupFrequencyEn = () => {
  const data = changePickupFrequencyDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addchangePickupFrequency = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-do-i-make-changes-to-my-service-or-pickup-frequency`,
    ) &&
    document.getElementById(`changePickupFrequencyJSONLD`) === null
  ) {
    const script = changePickupFrequencyJSONLDEn()
    addJSONLDToHead(script, `changePickupFrequencyJSONLD`)
  } else {
    removeElement(`changePickupFrequencyJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const changePickupFrequencyJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getchangePickupFrequencyEn(),
  }
  return FaqBagsterTemplate
}
